import ScheduleEvent from "@/schedule/entities/schedule-event";
import { parseISO } from "date-fns";

export default function toScheduleEvent(e: any): ScheduleEvent {
  return {
    id: e.scheduleId,
    userId: e.userId,
    projectId: e.projectId,
    projectName: e.projectName,
    title: e.title,
    description: e.description,
    start: parseISO(e.start),
    end: parseISO(e.end),
    tasks: e.tasks
  };
}
